module.exports = __webpack_public_path__ + "media/Video 5b.a797524a.mp4";